import { useCallback, useReducer } from 'react';

function useFormState<T>(initialData: T) {
    const [state, dispatch] = useReducer((current: T, update: Partial<T>) => ({ ...current, ...update }), initialData);

    const handleChange = useCallback(
        (data: Partial<T>) => {
            dispatch(data);
        },
        [dispatch]
    );

    return { state, handleChange } as const;
}
export default useFormState;
